module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 23);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("aphrodite");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@khanacademy/wonder-blocks-core");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@khanacademy/wonder-blocks-color");

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _aphrodite = __webpack_require__(1);

var _wonderBlocksColor = __webpack_require__(3);

var _wonderBlocksColor2 = _interopRequireDefault(_wonderBlocksColor);

var _wonderBlocksCore = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalFooter = function (_React$Component) {
    _inherits(ModalFooter, _React$Component);

    function ModalFooter() {
        _classCallCheck(this, ModalFooter);

        return _possibleConstructorReturn(this, (ModalFooter.__proto__ || Object.getPrototypeOf(ModalFooter)).apply(this, arguments));
    }

    _createClass(ModalFooter, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children;

            return React.createElement(
                _wonderBlocksCore.View,
                { style: [styles.footer, style] },
                children
            );
        }
    }]);

    return ModalFooter;
}(React.Component);

exports.default = ModalFooter;


var styles = _aphrodite.StyleSheet.create({
    footer: {
        flex: "0 0 auto",
        boxSizing: "border-box",
        minHeight: 64,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        paddingBottom: 8,

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",

        borderTopStyle: "solid",
        borderTopColor: _wonderBlocksColor2.default.offBlack16,
        borderTopWidth: 1
    }
});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _aphrodite = __webpack_require__(1);

var _wonderBlocksColor = __webpack_require__(3);

var _wonderBlocksColor2 = _interopRequireDefault(_wonderBlocksColor);

var _wonderBlocksCore = __webpack_require__(2);

var _wonderBlocksIcon = __webpack_require__(16);

var _wonderBlocksIconButton = __webpack_require__(15);

var _wonderBlocksIconButton2 = _interopRequireDefault(_wonderBlocksIconButton);

var _wonderBlocksToolbar = __webpack_require__(10);

var _wonderBlocksToolbar2 = _interopRequireDefault(_wonderBlocksToolbar);

var _modalContent = __webpack_require__(9);

var _modalContent2 = _interopRequireDefault(_modalContent);

var _modalHeader = __webpack_require__(8);

var _modalHeader2 = _interopRequireDefault(_modalHeader);

var _modalFooter = __webpack_require__(4);

var _modalFooter2 = _interopRequireDefault(_modalFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalPanel = function (_React$Component) {
    _inherits(ModalPanel, _React$Component);

    function ModalPanel() {
        _classCallCheck(this, ModalPanel);

        return _possibleConstructorReturn(this, (ModalPanel.__proto__ || Object.getPrototypeOf(ModalPanel)).apply(this, arguments));
    }

    _createClass(ModalPanel, [{
        key: "maybeRenderCloseButton",
        value: function maybeRenderCloseButton() {
            var _props = this.props,
                showCloseButton = _props.showCloseButton,
                onClickCloseButton = _props.onClickCloseButton,
                color = _props.color,
                titleBar = _props.titleBar;


            if (!showCloseButton) {
                return null;
            }

            // Figure out the background color that'll be behind the close button
            // If a titlebar is specified then we use that, otherwise we use the
            // default background color.
            var topBackgroundColor = titleBar && titleBar.props.color || color;

            return React.createElement(
                _wonderBlocksCore.View,
                {
                    style: [styles.closeButton, function (mediaSize) {
                        return mediaSize === "small" && styles.smallCloseButton;
                    }]
                },
                React.createElement(_wonderBlocksIconButton2.default, {
                    icon: _wonderBlocksIcon.icons.dismiss
                    // TODO(mdr): Translate this string for i18n.
                    , "aria-label": "Close modal",
                    onClick: onClickCloseButton,
                    kind: topBackgroundColor === "dark" ? "primary" : "tertiary",
                    light: topBackgroundColor === "dark"
                })
            );
        }
    }, {
        key: "render",
        value: function render() {
            var _props2 = this.props,
                content = _props2.content,
                titleBar = _props2.titleBar,
                header = _props2.header,
                footer = _props2.footer,
                showCloseButton = _props2.showCloseButton,
                scrollOverflow = _props2.scrollOverflow,
                color = _props2.color,
                style = _props2.style;


            var mainContent = content && (typeof content === "undefined" ? "undefined" : _typeof(content)) === "object" && content.type === _modalContent2.default ? content : React.createElement(
                _modalContent2.default,
                null,
                content
            );

            if (mainContent) {
                mainContent = React.cloneElement(mainContent, {
                    // Pass the scrollOverflow and header in to the main content
                    scrollOverflow: scrollOverflow,
                    header: header || mainContent.props.header,
                    // We override the styling of the main content to help position
                    // it if there is a title bar, footer, or close button being
                    // shown. We have to do this here as the ModalContent doesn't
                    // know about things being positioned around it.
                    style: [titleBar && styles.hasTitleBar, footer && styles.hasFooter, showCloseButton && !titleBar && function (mediaSize) {
                        return mediaSize === "small" && styles.smallWithCloseButton;
                    }, mainContent.props.style]
                });
            }

            return React.createElement(
                _wonderBlocksCore.View,
                {
                    style: [styles.wrapper, color === "dark" && styles.dark, style]
                },
                this.maybeRenderCloseButton(),
                titleBar,
                mainContent,
                !footer || (typeof footer === "undefined" ? "undefined" : _typeof(footer)) === "object" && footer.type === _modalFooter2.default ? footer : React.createElement(
                    _modalFooter2.default,
                    null,
                    footer
                )
            );
        }
    }]);

    return ModalPanel;
}(React.Component);

ModalPanel.defaultProps = {
    showCloseButton: false,
    scrollOverflow: true,
    color: "light",
    onClickCloseButton: function onClickCloseButton() {}
};
exports.default = ModalPanel;


var styles = _aphrodite.StyleSheet.create({
    wrapper: {
        flex: "1 1 auto",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        background: "white",
        boxSizing: "border-box",
        height: "100%",
        width: "100%"
    },

    closeButton: {
        position: "absolute",
        left: 8,
        top: 8,
        // This is to allow the button to be tab-ordered before the modal
        // content but still be above the header and content.
        zIndex: 1
    },

    smallCloseButton: {
        left: 8,
        top: 8
    },

    dark: {
        background: _wonderBlocksColor2.default.darkBlue,
        color: _wonderBlocksColor2.default.white
    },

    hasTitleBar: {
        paddingTop: 32
    },

    hasFooter: {
        paddingBottom: 32
    },

    smallWithCloseButton: {
        paddingTop: 64
    }
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _aphrodite = __webpack_require__(1);

var _wonderBlocksCore = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalDialog = function (_React$Component) {
    _inherits(ModalDialog, _React$Component);

    function ModalDialog() {
        _classCallCheck(this, ModalDialog);

        return _possibleConstructorReturn(this, (ModalDialog.__proto__ || Object.getPrototypeOf(ModalDialog)).apply(this, arguments));
    }

    _createClass(ModalDialog, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children;

            return React.createElement(
                _wonderBlocksCore.MediaLayout,
                { spec: _wonderBlocksCore.MEDIA_MODAL_SPEC },
                React.createElement(
                    _wonderBlocksCore.View,
                    {
                        style: [styles.wrapper, function (mediaSize) {
                            return mediaSize === "small" && styles.small;
                        }, style],
                        role: "dialog",
                        "aria-labelledby": "wb-modal-title"
                    },
                    children
                )
            );
        }
    }]);

    return ModalDialog;
}(React.Component);

exports.default = ModalDialog;


var styles = _aphrodite.StyleSheet.create({
    wrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        position: "relative",

        borderRadius: 4,
        overflow: "hidden"
    },

    // On small viewports, we consume the full screen size.
    small: {
        width: "100%",
        height: "100%",
        borderRadius: 0,
        flexDirection: "column"
    }
});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _aphrodite = __webpack_require__(1);

var _wonderBlocksColor = __webpack_require__(3);

var _wonderBlocksColor2 = _interopRequireDefault(_wonderBlocksColor);

var _wonderBlocksCore = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalHeader = function (_React$Component) {
    _inherits(ModalHeader, _React$Component);

    function ModalHeader() {
        _classCallCheck(this, ModalHeader);

        return _possibleConstructorReturn(this, (ModalHeader.__proto__ || Object.getPrototypeOf(ModalHeader)).apply(this, arguments));
    }

    _createClass(ModalHeader, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                color = _props.color,
                children = _props.children;

            return React.createElement(
                _wonderBlocksCore.View,
                {
                    style: [styles.header, color === "dark" && styles.dark, function (mediaSize) {
                        return mediaSize === "small" && styles.small;
                    }, style]
                },
                children
            );
        }
    }]);

    return ModalHeader;
}(React.Component);

ModalHeader.defaultProps = {
    color: "dark"
};
exports.default = ModalHeader;


var styles = _aphrodite.StyleSheet.create({
    header: {
        flex: "0 0 auto",
        boxSizing: "border-box",
        maxHeight: 108,
        paddingLeft: 64,
        paddingRight: 64,
        paddingTop: 8,
        paddingBottom: 8,

        display: "flex",
        flexDirection: "row"
    },

    dark: {
        background: _wonderBlocksColor2.default.darkBlue,
        color: _wonderBlocksColor2.default.white
    },

    small: {
        paddingLeft: 16,
        paddingRight: 16
    }
});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _aphrodite = __webpack_require__(1);

var _wonderBlocksCore = __webpack_require__(2);

var _modalHeader = __webpack_require__(8);

var _modalHeader2 = _interopRequireDefault(_modalHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalContent = function (_React$Component) {
    _inherits(ModalContent, _React$Component);

    function ModalContent() {
        _classCallCheck(this, ModalContent);

        return _possibleConstructorReturn(this, (ModalContent.__proto__ || Object.getPrototypeOf(ModalContent)).apply(this, arguments));
    }

    _createClass(ModalContent, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                header = _props.header,
                scrollOverflow = _props.scrollOverflow,
                style = _props.style,
                children = _props.children;


            return React.createElement(
                _wonderBlocksCore.View,
                {
                    style: [styles.wrapper, scrollOverflow && styles.scrollOverflow]
                },
                !header || (typeof header === "undefined" ? "undefined" : _typeof(header)) === "object" && header.type === _modalHeader2.default ? header : React.createElement(
                    _modalHeader2.default,
                    null,
                    header
                ),
                React.createElement(
                    _wonderBlocksCore.View,
                    {
                        style: [styles.content, function (mediaSize) {
                            return mediaSize === "small" && styles.small;
                        }, style]
                    },
                    children
                )
            );
        }
    }]);

    return ModalContent;
}(React.Component);

ModalContent.defaultProps = {
    scrollOverflow: true
};
exports.default = ModalContent;


var styles = _aphrodite.StyleSheet.create({
    wrapper: {
        flex: 1,

        // This helps to ensure that the paddingBottom is preserved when
        // the contents start to overflow, this goes away on display: flex
        display: "block"
    },

    scrollOverflow: {
        overflow: "auto"
    },

    content: {
        flex: 1,
        padding: 64,
        boxSizing: "border-box"
    },

    small: {
        padding: "32px 16px"
    }
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("@khanacademy/wonder-blocks-toolbar");

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * The attribute used to identify a modal launcher portal.
 */
var ModalLauncherPortalAttributeName = "data-modal-launcher-portal";

exports.ModalLauncherPortalAttributeName = ModalLauncherPortalAttributeName;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = maybeGetPortalMountedModalHostElement;

var _constants = __webpack_require__(11);

/**
 * From a given element, finds its next ancestor that is a modal launcher portal
 * element.
 * @param {?(Element | Text)} element The element whose ancestors are to be
 * walked.
 * @returns {?Element} The nearest parent modal launcher portal.
 */
function maybeGetNextAncestorModalLauncherPortal(element) {
    var candidateElement = element && element.parentElement;
    while (candidateElement && !candidateElement.hasAttribute(_constants.ModalLauncherPortalAttributeName)) {
        candidateElement = candidateElement.parentElement;
    }
    return candidateElement;
}

/**
 * From a given element, finds the next modal host that has been mounted in
 * a modal portal.
 * @param {?(Element | Text)} element The element whose ancestors are to be
 * walked.
 * @returns {?Element} The next portal-mounted modal host element.
 */

function maybeGetPortalMountedModalHostElement(element) {
    var modalLauncherPortal = maybeGetNextAncestorModalLauncherPortal(element);
    // If we have a portal, then the first child should be the actual
    // data-react-root that contains the modal, which is what we want to
    // return.
    return modalLauncherPortal && modalLauncherPortal.firstElementChild;
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _aphrodite = __webpack_require__(1);

var _wonderBlocksCore = __webpack_require__(2);

var _wonderBlocksColor = __webpack_require__(3);

var _wonderBlocksColor2 = _interopRequireDefault(_wonderBlocksColor);

var _modalDialog = __webpack_require__(6);

var _modalDialog2 = _interopRequireDefault(_modalDialog);

var _modalPanel = __webpack_require__(5);

var _modalPanel2 = _interopRequireDefault(_modalPanel);

var _modalFooter = __webpack_require__(4);

var _modalFooter2 = _interopRequireDefault(_modalFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContentWrapper = function (_React$Component) {
    _inherits(ContentWrapper, _React$Component);

    function ContentWrapper() {
        _classCallCheck(this, ContentWrapper);

        return _possibleConstructorReturn(this, (ContentWrapper.__proto__ || Object.getPrototypeOf(ContentWrapper)).apply(this, arguments));
    }

    _createClass(ContentWrapper, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                onClickCloseButton = _props.onClickCloseButton,
                content = _props.content,
                footer = _props.footer,
                mediaSize = _props.mediaSize;


            if (mediaSize !== "small") {
                return React.createElement(
                    _wonderBlocksCore.View,
                    null,
                    React.createElement(_modalPanel2.default, {
                        showCloseButton: true,
                        onClickCloseButton: onClickCloseButton,
                        content: content,
                        footer: footer
                    })
                );
            }

            return React.createElement(
                _wonderBlocksCore.View,
                { style: styles.contentFooterWrapper },
                React.createElement(
                    _wonderBlocksCore.View,
                    { style: styles.smallContentWrapper },
                    React.createElement(_modalPanel2.default, {
                        showCloseButton: true,
                        onClickCloseButton: onClickCloseButton,
                        content: content,
                        scrollOverflow: false
                    })
                ),
                footer && React.createElement(
                    _wonderBlocksCore.View,
                    { style: styles.smallFooter },
                    !footer || (typeof footer === "undefined" ? "undefined" : _typeof(footer)) === "object" && footer.type === _modalFooter2.default ? footer : React.createElement(
                        _modalFooter2.default,
                        null,
                        footer
                    )
                )
            );
        }
    }]);

    return ContentWrapper;
}(React.Component);

ContentWrapper.defaultProps = {
    onClickCloseButton: function onClickCloseButton() {}
};


var WrappedContentWrapper = (0, _wonderBlocksCore.MediaLayoutWrapper)(ContentWrapper);

/**
 * A one-column modal layout.
 */

var OneColumnModal = function (_React$Component2) {
    _inherits(OneColumnModal, _React$Component2);

    function OneColumnModal() {
        _classCallCheck(this, OneColumnModal);

        return _possibleConstructorReturn(this, (OneColumnModal.__proto__ || Object.getPrototypeOf(OneColumnModal)).apply(this, arguments));
    }

    _createClass(OneColumnModal, [{
        key: "render",
        value: function render() {
            return React.createElement(
                _modalDialog2.default,
                {
                    style: [styles.dialog, function (mediaSize) {
                        return mediaSize !== "small" && styles.largeDialog;
                    }]
                },
                React.createElement(WrappedContentWrapper, this.props)
            );
        }
    }]);

    return OneColumnModal;
}(React.Component);

OneColumnModal.defaultProps = {
    onClickCloseButton: function onClickCloseButton() {}
};
exports.default = OneColumnModal;


var styles = _aphrodite.StyleSheet.create({
    dialog: {
        background: _wonderBlocksColor2.default.white
    },

    largeDialog: {
        width: "64.65%",
        maxWidth: 662,
        maxHeight: "90%"
    },

    contentFooterWrapper: {
        flexDirection: "column",
        height: "100%"
    },

    smallContentWrapper: {
        flexDirection: "column",
        overflow: "auto"
    },

    smallFooter: {
        minHeight: 64
    }
});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _aphrodite = __webpack_require__(1);

var _wonderBlocksCore = __webpack_require__(2);

var _wonderBlocksColor = __webpack_require__(3);

var _wonderBlocksColor2 = _interopRequireDefault(_wonderBlocksColor);

var _modalDialog = __webpack_require__(6);

var _modalDialog2 = _interopRequireDefault(_modalDialog);

var _modalFooter = __webpack_require__(4);

var _modalFooter2 = _interopRequireDefault(_modalFooter);

var _modalPanel = __webpack_require__(5);

var _modalPanel2 = _interopRequireDefault(_modalPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContentWrapper = function (_React$Component) {
    _inherits(ContentWrapper, _React$Component);

    function ContentWrapper() {
        _classCallCheck(this, ContentWrapper);

        return _possibleConstructorReturn(this, (ContentWrapper.__proto__ || Object.getPrototypeOf(ContentWrapper)).apply(this, arguments));
    }

    _createClass(ContentWrapper, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                onClickCloseButton = _props.onClickCloseButton,
                sidebar = _props.sidebar,
                content = _props.content,
                footer = _props.footer,
                mediaSize = _props.mediaSize;


            if (mediaSize !== "small") {
                return React.createElement(
                    _wonderBlocksCore.View,
                    { style: styles.contentWrapper },
                    React.createElement(_modalPanel2.default, {
                        showCloseButton: true,
                        color: "dark",
                        onClickCloseButton: onClickCloseButton,
                        style: styles.column,
                        content: sidebar
                    }),
                    React.createElement(_modalPanel2.default, {
                        style: styles.column,
                        content: content,
                        footer: footer
                    })
                );
            }

            return React.createElement(
                _wonderBlocksCore.View,
                { style: styles.contentFooterWrapper },
                React.createElement(
                    _wonderBlocksCore.View,
                    {
                        style: [styles.contentWrapper, styles.smallContentWrapper]
                    },
                    React.createElement(_modalPanel2.default, {
                        showCloseButton: true,
                        color: "dark",
                        onClickCloseButton: onClickCloseButton,
                        style: styles.smallColumn,
                        content: sidebar,
                        scrollOverflow: false
                    }),
                    React.createElement(_modalPanel2.default, {
                        style: styles.smallColumn,
                        content: content,
                        scrollOverflow: false
                    })
                ),
                footer && React.createElement(
                    _wonderBlocksCore.View,
                    { style: styles.smallFooter },
                    !footer || (typeof footer === "undefined" ? "undefined" : _typeof(footer)) === "object" && footer.type === _modalFooter2.default ? footer : React.createElement(
                        _modalFooter2.default,
                        null,
                        footer
                    )
                )
            );
        }
    }]);

    return ContentWrapper;
}(React.Component);

ContentWrapper.defaultProps = {
    onClickCloseButton: function onClickCloseButton() {}
};


var WrappedContentWrapper = (0, _wonderBlocksCore.MediaLayoutWrapper)(ContentWrapper);

/**
 * A two-column modal layout.
 */

var TwoColumnModal = function (_React$Component2) {
    _inherits(TwoColumnModal, _React$Component2);

    function TwoColumnModal() {
        _classCallCheck(this, TwoColumnModal);

        return _possibleConstructorReturn(this, (TwoColumnModal.__proto__ || Object.getPrototypeOf(TwoColumnModal)).apply(this, arguments));
    }

    _createClass(TwoColumnModal, [{
        key: "render",
        value: function render() {
            return React.createElement(
                _modalDialog2.default,
                {
                    style: function style(mediaSize) {
                        return mediaSize === "small" ? styles.smallDialog : styles.dialog;
                    }
                },
                React.createElement(WrappedContentWrapper, this.props)
            );
        }
    }]);

    return TwoColumnModal;
}(React.Component);

TwoColumnModal.defaultProps = {
    onClickCloseButton: function onClickCloseButton() {}
};
exports.default = TwoColumnModal;


var styles = _aphrodite.StyleSheet.create({
    dialog: {
        width: "86.72%",
        maxWidth: 888,
        height: "60.42%",
        minHeight: 464
    },

    smallDialog: {
        background: _wonderBlocksColor2.default.white
    },

    column: {
        flex: "0 0 50%"
    },

    smallColumn: {
        flex: "0 0 auto",
        height: "auto"
    },

    contentFooterWrapper: {
        flexDirection: "column",
        height: "100%"
    },

    contentWrapper: {
        flexDirection: "row",
        height: "100%",
        width: "100%"
    },

    smallContentWrapper: {
        flexDirection: "column",
        overflow: "auto"
    },

    smallFooter: {
        minHeight: 64
    }
});

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = require("@khanacademy/wonder-blocks-icon-button");

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = require("@khanacademy/wonder-blocks-icon");

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _aphrodite = __webpack_require__(1);

var _wonderBlocksToolbar = __webpack_require__(10);

var _wonderBlocksToolbar2 = _interopRequireDefault(_wonderBlocksToolbar);

var _modalDialog = __webpack_require__(6);

var _modalDialog2 = _interopRequireDefault(_modalDialog);

var _modalPanel = __webpack_require__(5);

var _modalPanel2 = _interopRequireDefault(_modalPanel);

var _modalContent = __webpack_require__(9);

var _modalContent2 = _interopRequireDefault(_modalContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The "standard" modal layout: a titlebar, a content area, and a footer.
 */
var StandardModal = function (_React$Component) {
    _inherits(StandardModal, _React$Component);

    function StandardModal() {
        _classCallCheck(this, StandardModal);

        return _possibleConstructorReturn(this, (StandardModal.__proto__ || Object.getPrototypeOf(StandardModal)).apply(this, arguments));
    }

    _createClass(StandardModal, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                onClickCloseButton = _props.onClickCloseButton,
                title = _props.title,
                subtitle = _props.subtitle,
                header = _props.header,
                footer = _props.footer,
                content = _props.content,
                preview = _props.preview;


            return React.createElement(
                _modalDialog2.default,
                {
                    style: function style(mediaSize) {
                        return mediaSize !== "small" && styles.wrapper;
                    }
                },
                React.createElement(_modalPanel2.default, {
                    showCloseButton: true,
                    onClickCloseButton: onClickCloseButton,
                    titleBar: React.createElement(_wonderBlocksToolbar2.default, {
                        title: title,
                        subtitle: subtitle,
                        color: header ? "dark" : "light"
                    }),
                    header: header,
                    content: content,
                    footer: footer
                }),
                preview && React.createElement(_modalPanel2.default, {
                    color: "dark",
                    style: (styles.preview, function (mediaSize) {
                        return mediaSize === "small" && styles.smallPreview;
                    }),
                    content: React.createElement(
                        _modalContent2.default,
                        { style: styles.previewContent },
                        preview
                    )
                })
            );
        }
    }]);

    return StandardModal;
}(React.Component);

StandardModal.defaultProps = {
    onClickCloseButton: function onClickCloseButton() {}
};
exports.default = StandardModal;


var styles = _aphrodite.StyleSheet.create({
    wrapper: {
        width: "93.75%",
        maxWidth: 960,
        height: "81.25%",
        maxHeight: 624
    },

    preview: {
        maxWidth: 392,
        flex: "1 0 auto"
    },

    previewContent: {
        padding: "0 64px 0 0"
    },

    smallPreview: {
        display: "none"
    }
});

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * A UI-less component that lets `ModalLauncher` disable page scroll.
 *
 * The positioning of the modal requires some global page state changed
 * unfortunately, and this handles that in an encapsulated way.
 *
 * NOTE(mdr): This component was copied from webapp. Be wary of sync issues. It
 *     also doesn't have unit tests, and we haven't added any, since it's a
 *     relatively stable component that has now been stress-tested lots in prod.
 */

var needsHackyMobileSafariScrollDisabler = function () {
    var userAgent = window.navigator.userAgent;
    return userAgent.indexOf("iPad") > -1 || userAgent.indexOf("iPhone") > -1;
}();

var ScrollDisabler = function (_Component) {
    _inherits(ScrollDisabler, _Component);

    function ScrollDisabler() {
        _classCallCheck(this, ScrollDisabler);

        return _possibleConstructorReturn(this, (ScrollDisabler.__proto__ || Object.getPrototypeOf(ScrollDisabler)).apply(this, arguments));
    }

    _createClass(ScrollDisabler, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            if (ScrollDisabler.numModalsOpened === 0) {
                var body = document.body;
                if (!body) {
                    throw new Error("couldn't find document.body");
                }

                // Prevent scrolling of the background, the first time a modal is
                // opened.
                ScrollDisabler.oldOverflow = body.style.overflow;
                ScrollDisabler.oldScrollY = window.scrollY;

                // We need to grab all of the original style properties before we
                // modified any of them.
                if (needsHackyMobileSafariScrollDisabler) {
                    ScrollDisabler.oldPosition = body.style.position;
                    ScrollDisabler.oldWidth = body.style.width;
                    ScrollDisabler.oldTop = body.style.top;
                }

                body.style.overflow = "hidden";

                // On mobile Safari, overflow: hidden is not enough, position:
                // fixed is also required.  Setting style.top = -scollTop maintains
                // the scroll position (without which we'd scroll to the top).
                if (needsHackyMobileSafariScrollDisabler) {
                    body.style.position = "fixed";
                    body.style.width = "100%";
                    body.style.top = -ScrollDisabler.oldScrollY + "px";
                }
            }
            ScrollDisabler.numModalsOpened++;
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            ScrollDisabler.numModalsOpened--;
            if (ScrollDisabler.numModalsOpened === 0) {
                var body = document.body;
                if (!body) {
                    throw new Error("couldn't find document.body");
                }

                // Reset all values on the closing of the final modal.
                body.style.overflow = ScrollDisabler.oldOverflow;
                if (needsHackyMobileSafariScrollDisabler) {
                    body.style.position = ScrollDisabler.oldPosition;
                    body.style.width = ScrollDisabler.oldWidth;
                    body.style.top = ScrollDisabler.oldTop;
                }
                window.scrollTo(0, ScrollDisabler.oldScrollY);
            }
        }
    }, {
        key: "render",
        value: function render() {
            return null;
        }
    }]);

    return ScrollDisabler;
}(_react.Component);

ScrollDisabler.numModalsOpened = 0;
exports.default = ScrollDisabler;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(7);

var ReactDOM = _interopRequireWildcard(_reactDom);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This component ensures that focus stays within itself. If the user uses Tab
 * at the end of the modal, or Shift-Tab at the start of the modal, then this
 * component wraps focus to the start/end respectively.
 *
 * We use this in `ModalBackdrop` to ensure that focus stays within the launched
 * modal.
 *
 * Adapted from the WAI-ARIA dialog behavior example.
 * https://www.w3.org/TR/2017/NOTE-wai-aria-practices-1.1-20171214/examples/dialog-modal/dialog.html
 *
 * NOTE(mdr): This component frequently references the "modal" and the "modal
 *     root", to aid readability in this package. But this component isn't
 *     actually coupled to the modal, and these could be renamed "children"
 *     instead if we were to generalize!
 */
var FocusTrap = function (_React$Component) {
    _inherits(FocusTrap, _React$Component);

    function FocusTrap() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FocusTrap);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call.apply(_ref, [this].concat(args))), _this), _this._lastNodeFocusedInModal = null, _this._ignoreFocusChanges = false, _this._handleGlobalFocus = function (e) {
            // If we're busy applying our own programmatic focus, we ignore focus
            // changes, to avoid an infinite loop.
            if (_this._ignoreFocusChanges) {
                return;
            }

            var target = e.target;
            if (!(target instanceof Node)) {
                // Sometimes focus events trigger on the document itself. Ignore!
                return;
            }

            var modalRoot = _this._getModalRoot();
            if (modalRoot.contains(target)) {
                // If the newly focused node is inside the modal, we just keep track
                // of that.
                _this._lastNodeFocusedInModal = target;
            } else {
                // If the newly focused node is outside the modal, we try refocusing
                // the first focusable node of the modal. (This could be the user
                // pressing Tab on the last node of the modal, or focus escaping in
                // some other way.)
                _this._focusFirstElementIn(modalRoot);

                // But, if it turns out that the first focusable node of the modal
                // was what we were previously focusing, then this is probably the
                // user pressing Shift-Tab on the first node, wanting to go to the
                // end. So, we instead try focusing the last focusable node of the
                // modal.
                if (document.activeElement === _this._lastNodeFocusedInModal) {
                    _this._focusLastElementIn(modalRoot);
                }

                // Focus should now be inside the modal, so record the newly-focused
                // node as the last node focused in the modal.
                _this._lastNodeFocusedInModal = document.activeElement;
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FocusTrap, [{
        key: "componentDidMount",

        /** The most recent node _inside this component_ to receive focus. */
        value: function componentDidMount() {
            window.addEventListener("focus", this._handleGlobalFocus, true);
        }

        /**
         * Whether we're currently applying programmatic focus, and should therefore
         * ignore focus change events.
         */

    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            window.removeEventListener("focus", this._handleGlobalFocus, true);
        }
    }, {
        key: "_getModalRoot",


        /** Get the outermost DOM node of our children. */
        value: function _getModalRoot() {
            var modalRoot = ReactDOM.findDOMNode(this);
            if (!modalRoot) {
                throw new Error("Assertion error: modal root should exist after mount");
            }
            return modalRoot;
        }

        /** Try to focus the given node. Return true iff successful. */

    }, {
        key: "_tryToFocus",
        value: function _tryToFocus(node) {
            if (node instanceof HTMLElement) {
                this._ignoreFocusChanges = true;
                try {
                    node.focus();
                } catch (e) {
                    // ignore error
                }
                this._ignoreFocusChanges = false;

                return document.activeElement === node;
            }
        }

        /**
         * Focus the first focusable descendant of the given node.
         *
         * Return true if we succeed. Or, if the given node has no focusable
         * descendants, return false.
         */

    }, {
        key: "_focusFirstElementIn",
        value: function _focusFirstElementIn(currentParent) {
            var children = currentParent.childNodes;
            for (var i = 0; i < children.length; i++) {
                var child = children[i];
                if (this._tryToFocus(child) || this._focusFirstElementIn(child)) {
                    return true;
                }
            }
            return false;
        }

        /**
         * Focus the last focusable descendant of the given node.
         *
         * Return true if we succeed. Or, if the given node has no focusable
         * descendants, return false.
         */

    }, {
        key: "_focusLastElementIn",
        value: function _focusLastElementIn(currentParent) {
            var children = currentParent.childNodes;
            for (var i = children.length - 1; i >= 0; i--) {
                var child = children[i];
                if (this._tryToFocus(child) || this._focusLastElementIn(child)) {
                    return true;
                }
            }
            return false;
        }

        /** This method is called when any node on the page is focused. */

    }, {
        key: "render",
        value: function render() {
            return this.props.children;
        }
    }]);

    return FocusTrap;
}(React.Component);

exports.default = FocusTrap;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(7);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _aphrodite = __webpack_require__(1);

var _wonderBlocksColor = __webpack_require__(3);

var _wonderBlocksColor2 = _interopRequireDefault(_wonderBlocksColor);

var _wonderBlocksCore = __webpack_require__(2);

var _focusTrap = __webpack_require__(19);

var _focusTrap2 = _interopRequireDefault(_focusTrap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A private component used by ModalLauncher. This is the fixed-position
 * container element that gets mounted outside the DOM. It overlays the modal
 * content (provided as `children`) over the content, with a gray backdrop
 * behind it.
 *
 * This component is also responsible for cloning the provided modal `children`,
 * and adding an `onClickCloseButton` prop that will call `onCloseModal`. If an
 * `onClickCloseButton` prop is already provided, the two are merged.
 */
var ModalBackdrop = function (_React$Component) {
    _inherits(ModalBackdrop, _React$Component);

    function ModalBackdrop() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ModalBackdrop);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalBackdrop.__proto__ || Object.getPrototypeOf(ModalBackdrop)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
            // Was the lowest-level click target (`e.target`) the positioner element
            // (`e.currentTarget`)?
            if (e.target === e.currentTarget) {
                _this.props.onCloseModal();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ModalBackdrop, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            // Focus the last button in the modal, on the assumption that it'll be
            // a sensible default action.
            //
            // TODO(mdr): Not sure how robust this is; or whether we'll sometimes
            //     want the default to be something in the modal content, or a
            var node = ReactDOM.findDOMNode(this);
            if (!node) {
                return;
            }

            var buttons = node.querySelectorAll("button");
            var lastButton = buttons[buttons.length - 1];
            if (!lastButton) {
                return;
            }
            lastButton.focus();
        }

        /**
         * When the user clicks on the gray backdrop area (i.e., the click came
         * _directly_ from the positioner, not bubbled up from its children), close
         * the modal.
         */

    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var children = this.props.children;
            var clonedChildren = React.cloneElement(children, {
                onClickCloseButton: function onClickCloseButton() {
                    if (typeof children.props.onClickCloseButton === "function") {
                        children.props.onClickCloseButton();
                    }
                    _this2.props.onCloseModal();
                }
            });

            return React.createElement(
                _wonderBlocksCore.View,
                { style: styles.modalPositioner, onClick: this.handleClick },
                React.createElement("div", { tabIndex: "0" }),
                React.createElement(
                    _focusTrap2.default,
                    null,
                    clonedChildren
                ),
                React.createElement("div", { tabIndex: "0" })
            );
        }
    }]);

    return ModalBackdrop;
}(React.Component);

exports.default = ModalBackdrop;


var styles = _aphrodite.StyleSheet.create({
    modalPositioner: {
        position: "fixed",
        left: 0,
        top: 0,

        // This z-index is copied from the Khan Academy webapp.
        //
        // TODO(mdr): Should we keep this in a constants file somewhere? Or
        //     not hardcode it at all, and provide it to Wonder Blocks via
        //     configuration?
        zIndex: 1080,

        width: "100%",
        height: "100%",

        alignItems: "center",
        justifyContent: "center",

        // If the modal ends up being too big for the viewport (e.g., the min
        // height is triggered), add another scrollbar specifically for
        // scrolling modal content.
        //
        // TODO(mdr): The specified behavior is that the modal should scroll
        //     with the rest of the page, rather than separately, if overflow
        //     turns out to be necessary. That sounds hard to do; punting for
        //     now!
        overflow: "auto",

        background: _wonderBlocksColor2.default.offBlack64
    }
});

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(7);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _constants = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A private component used by ModalLauncher, that behaves similarly to a React
 * "portal". It renders its children in a new node in `document.body`, rather
 * than in its natural position in the DOM tree.
 *
 * NOTE(mdr): Once we upgrade to React 16, maybe we can use built-in portals!
 */
var ModalLauncherPortal = function (_React$Component) {
    _inherits(ModalLauncherPortal, _React$Component);

    function ModalLauncherPortal() {
        _classCallCheck(this, ModalLauncherPortal);

        return _possibleConstructorReturn(this, (ModalLauncherPortal.__proto__ || Object.getPrototypeOf(ModalLauncherPortal)).apply(this, arguments));
    }

    _createClass(ModalLauncherPortal, [{
        key: "componentDidMount",


        /**
         * When we mount, we also mount our children into a new child of
         * `document.body`.
         */
        value: function componentDidMount() {
            var root = this._getRoot();

            // Create a new destination node, and add it to the root.
            // The data attribute is used in unit tests, to identify which
            // ancestors of `children` were created by `ModalLauncherPortal`.
            var destination = document.createElement("div");
            destination.setAttribute(_constants.ModalLauncherPortalAttributeName, "");
            root.appendChild(destination);

            // Render the modal into the destination node.
            ReactDOM.render(this.props.children, destination);

            // Save the destination node, so we can remove it on unmount.
            this._destination = destination;
        }

        /**
         * When we unmount, we also unmount our children, and the new child of
         * `document.body` we created.
         */

    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            var destination = this._destination;
            if (!destination) {
                return;
            }

            ReactDOM.unmountComponentAtNode(destination);

            if (!destination.parentNode) {
                return;
            }
            destination.parentNode.removeChild(destination);
        }
    }, {
        key: "_getRoot",
        value: function _getRoot() {
            var root = document.body;
            if (!root) {
                throw new Error("can't mount modal without a document.body");
            }

            return root;
        }
    }, {
        key: "render",
        value: function render() {
            return null;
        }
    }]);

    return ModalLauncherPortal;
}(React.Component);

exports.default = ModalLauncherPortal;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _wonderBlocksCore = __webpack_require__(2);

var _modalLauncherPortal = __webpack_require__(21);

var _modalLauncherPortal2 = _interopRequireDefault(_modalLauncherPortal);

var _modalBackdrop = __webpack_require__(20);

var _modalBackdrop2 = _interopRequireDefault(_modalBackdrop);

var _scrollDisabler = __webpack_require__(18);

var _scrollDisabler2 = _interopRequireDefault(_scrollDisabler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This component enables you to launch a modal, covering the screen.
 *
 * Children have access to `openModal` function via the function-as-children
 * pattern, so one common use case is for this component to wrap a button:
 *
 * ```js
 * <ModalLauncher modal={<TwoColumnModal ... />}>
 *     {({openModal}) => <button onClick={openModal}>Learn more</button>}
 * </ModalLauncher>
 * ```
 *
 * The actual modal itself is constructed separately, using a layout component
 * like StandardModal, OneColumnModal, or TwoColumnModal, and is provided via
 * the `modal` prop.
 */
var ModalLauncher = function (_React$Component) {
    _inherits(ModalLauncher, _React$Component);

    function ModalLauncher() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ModalLauncher);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalLauncher.__proto__ || Object.getPrototypeOf(ModalLauncher)).call.apply(_ref, [this].concat(args))), _this), _this.state = { opened: false }, _this._openModal = function () {
            _this.setState({ opened: true });
        }, _this.handleCloseModal = function () {
            _this.setState({ opened: false }, function () {
                _this.props.onClose && _this.props.onClose();
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ModalLauncher, [{
        key: "_renderModal",
        value: function _renderModal() {
            if (typeof this.props.modal === "function") {
                return this.props.modal({
                    closeModal: this.handleCloseModal
                });
            } else {
                return this.props.modal;
            }
        }
    }, {
        key: "render",
        value: function render() {
            var renderedChildren = this.props.children({
                openModal: this._openModal
            });

            return (
                // TODO(mdr): This can be a fragment once we're on React 16.
                React.createElement(
                    _wonderBlocksCore.View,
                    null,
                    renderedChildren,
                    this.state.opened && React.createElement(
                        _modalLauncherPortal2.default,
                        null,
                        React.createElement(
                            _modalBackdrop2.default,
                            { onCloseModal: this.handleCloseModal },
                            this._renderModal()
                        )
                    ),
                    this.state.opened && React.createElement(ModalLauncherKeypressListener, {
                        onClose: this.handleCloseModal
                    }),
                    this.state.opened && React.createElement(_scrollDisabler2.default, null)
                )
            );
        }
    }]);

    return ModalLauncher;
}(React.Component);

/** A component that, when mounted, calls `onClose` when Escape is pressed. */


exports.default = ModalLauncher;

var ModalLauncherKeypressListener = function (_React$Component2) {
    _inherits(ModalLauncherKeypressListener, _React$Component2);

    function ModalLauncherKeypressListener() {
        var _ref2;

        var _temp2, _this2, _ret2;

        _classCallCheck(this, ModalLauncherKeypressListener);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = ModalLauncherKeypressListener.__proto__ || Object.getPrototypeOf(ModalLauncherKeypressListener)).call.apply(_ref2, [this].concat(args))), _this2), _this2._handleKeyup = function (e) {
            // We check the key as that's keyboard layout agnostic and also avoids
            // the minefield of deprecated number type properties like keyCode and
            // which, with the replacement code, which uses a string instead.
            if (e.key === "Escape") {
                // Stop the event going any further.
                // For cancellation events, like the Escape key, we generally should
                // air on the side of caution and only allow it to cancel one thing.
                // So, it's polite for us to stop propagation of the event.
                // Otherwise, we end up with UX where one Escape key press
                // unexpectedly cancels multiple things.
                e.preventDefault();
                e.stopPropagation();
                _this2.props.onClose();
            }
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    _createClass(ModalLauncherKeypressListener, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            window.addEventListener("keyup", this._handleKeyup);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            window.removeEventListener("keyup", this._handleKeyup);
        }
    }, {
        key: "render",
        value: function render() {
            return null;
        }
    }]);

    return ModalLauncherKeypressListener;
}(React.Component);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.maybeGetPortalMountedModalHostElement = exports.OneColumnModal = exports.TwoColumnModal = exports.StandardModal = exports.ModalLauncher = undefined;

var _modalLauncher = __webpack_require__(22);

var _modalLauncher2 = _interopRequireDefault(_modalLauncher);

var _standardModal = __webpack_require__(17);

var _standardModal2 = _interopRequireDefault(_standardModal);

var _twoColumnModal = __webpack_require__(14);

var _twoColumnModal2 = _interopRequireDefault(_twoColumnModal);

var _oneColumnModal = __webpack_require__(13);

var _oneColumnModal2 = _interopRequireDefault(_oneColumnModal);

var _maybeGetPortalMountedModalHostElement = __webpack_require__(12);

var _maybeGetPortalMountedModalHostElement2 = _interopRequireDefault(_maybeGetPortalMountedModalHostElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ModalLauncher = _modalLauncher2.default;
exports.StandardModal = _standardModal2.default;
exports.TwoColumnModal = _twoColumnModal2.default;
exports.OneColumnModal = _oneColumnModal2.default;
exports.maybeGetPortalMountedModalHostElement = _maybeGetPortalMountedModalHostElement2.default;

/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@khanacademy/wonder-blocks-modal/index.js
// module id = 1096
// module chunks = 0